import { createRef, FC, ReactNode } from 'react';

import {
  HelpComponentWrapper,
  HelpText,
  useConfigSlice,
  HelpChapterProps,
  useTranslation,
  useIsLargerThanWide,
  useIsLandscape,
  useMedia,
  useIsSmallerThanNarrow,
} from '@pp/core';

import { Bets } from '../../../config/bets';
import { BetSpot } from '../../gameGrid/betSpot';
import { BettingGrid } from '../../gameGrid/bettingGrid';
import styles from './HelpChapters.module.css';

export const HelpChapterHowToPlay: FC<HelpChapterProps> = ({ content }) => {
  const compliance = useConfigSlice.compliance();
  const maxPLayerLimitInfo = compliance?.maxPlayerLimitInfo;
  const gridRef = createRef<HTMLDivElement>();
  const isWide = useIsLargerThanWide();
  const isLandscape = useIsLandscape();
  const isNarrowWidth = useIsSmallerThanNarrow();
  const isCompactPortrait = useMedia('(min-width: 375px) and (max-height: 657px)');
  const tableNameKey = useConfigSlice.tableConfig()?.tableName ?? '';
  const { translations } = useTranslation();
  const tableName = translations[tableNameKey] || tableNameKey;

  const betDefaultProps = {
    value: 0,
    disabled: false,
    onBet: () => null,
    multival: 0,
  };

  if (!content) return null;
  const EXCLUDE_KEYS: string[] = ['title', 'gameLayout', 'SWISS_MARKET_TEXT'];
  const renderBetSpot = (bet: Bets, multiplier: number): ReactNode => (
    <BetSpot {...betDefaultProps} bet={bet} multiplier={multiplier} megaMultiplier={0} isMegaWin={true} />
  );

  const minWidthBettingGridLSVal = isLandscape ? '600px' : '300px';
  const minWidthBettingGrid = isWide ? '1500px' : minWidthBettingGridLSVal;

  const maxWidthBettingGridLSVal = isLandscape ? 'unset' : '300px';
  const maxWidthBettingGrid = isWide || isNarrowWidth || isCompactPortrait ? 'unset' : maxWidthBettingGridLSVal;

  return (
    <div>
      <p>
        <HelpText dynamicValues={{ TABLE_NAME: `${tableName}` }}>{String(content.gameLayout)}</HelpText>
      </p>
      <HelpComponentWrapper
        style={{
          margin: 'var(--core-spacing-regular) auto var(--core-spacing-large)',
        }}
        isOriginalHeight={false}
        minWidth={minWidthBettingGrid}
        maxWidth={maxWidthBettingGrid}
      >
        <BettingGrid
          isCollapsed={false}
          gridRef={gridRef}
          hidden={false}
          targetScale={1}
          className={styles.helpChapter__bettingGrid}
        >
          {renderBetSpot(Bets.One, 1)}
          {renderBetSpot(Bets.Two, 2)}
          {renderBetSpot(Bets.Five, 5)}
          {renderBetSpot(Bets.Eight, 8)}
          {renderBetSpot(Bets.Ten, 10)}
          {renderBetSpot(Bets.Fifteen, 15)}
          {renderBetSpot(Bets.Twenty, 20)}
          {renderBetSpot(Bets.Thirty, 30)}
          {renderBetSpot(Bets.Forty, 40)}
        </BettingGrid>
      </HelpComponentWrapper>
      {Object.keys(content)
        ?.filter((content) => EXCLUDE_KEYS.indexOf(content) === -1)
        ?.map((text: string) => {
          return (
            <p key={text}>
              <HelpText dynamicValues={{ TABLE_NAME: `${tableName}` }}>{String(content[text])}</HelpText>
            </p>
          );
        })}

      {maxPLayerLimitInfo && <HelpText>{String(content.SWISS_MARKET_TEXT)}</HelpText>}
    </div>
  );
};
